var hsDrawerCheck = setInterval(function(){
if (document.querySelectorAll('.hs-finalize-purchase').length) {
    clearInterval(hsDrawerCheck);
    var $target = document.querySelectorAll('.hs-finalize-purchase')[0];
    $target.innerHTML = document.querySelector('#hs-checkbox-como-terms').innerHTML + $target.innerHTML;
    document.querySelector('#hs-checkbox-como-terms').remove();
}
}, 1000);

document.querySelectorAll('.app-ot-cookie-manager').forEach(function(node){
    node.addEventListener('click', function(e){
        document.querySelectorAll('.ot-floating-button__open')[0].click();
        return false;
    });
});

var collectionsHideSavingsText = "bao-bao-issey-miyake,me-issey-miyake,pleats-please-issey-miyake,amiri,dries-van-noten,jacquemus,sacai".split(',');
var collectionsNoLinebreak = "".split(',');

var brandsCustomTitles = "BAO BAO ISSEY MIYAKE, PLEATS PLEASE ISSEY MIYAKE, DKNY, me ISSEY MIYAKE, DKNY Sport, DKNY Special, OAMC, CLOT, MM6 Maison Margiela, Mulberry. AMIRI, ck Calvin Klein, COMME des GARCONS BLACK, COMME des GARCONS COMME des GARCONS, COMME des GARCONS GIRL, COMME des GARCONS HOMME PLUS, COMME des GARCONS PARFUMS, COMME des GARCONS PLAY, COMME des GARCONS SHIRT, COMME des GARCONS WALLET, JW Anderson, MIISTA, MSGM, STELLA McCARTNEY, TEAM WANG design, PS Paul Smith, rag & bone".split(',').map(brand => brand.trim());

(function($){
  $(function(){
    $('.slick-featured-collection').each(function(){
    var $this = $(this),
        autoplaySpeed = parseInt($this.attr('slick-autoplay-speed')),
        autoplaySpeedMobile = parseInt($this.attr('slick-autoplay-speed-mobile')),
        perSlide = parseInt($this.attr('slick-per-slide')),
        perSlideMobile = parseInt($this.attr('slick-per-slide-mobile'));
        
    $this.on('init', function() {
            $this.find('.slick-list').css('overflow','visible');
        })

    $this.slick({
        mobileFirst: true,
        autoplay: autoplaySpeedMobile > 0,
        autoplaySpeed: autoplaySpeedMobile * 1000,
        slidesToScroll: perSlideMobile,
        slidesToShow: perSlideMobile,
        prevArrow: '<button type="button" class="slick-prev"><img src="//th.club21.com/cdn/shop/t/80/assets/icon-chevron-l-50.png?v=57729509988535547171788748228"></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="//th.club21.com/cdn/shop/t/80/assets/icon-chevron-r-50.png?v=179895502095744357951788748228"></button>',
        responsive: [
        {
            breakpoint: 766,
            settings: {
            autoplay: autoplaySpeed > 0,
            autoplaySpeed: autoplaySpeed * 1000,
            slidesToScroll: perSlide,
            slidesToShow: perSlide
            }
        }
        ]
    });
    });

    var productSingleDescriptionFullWidthMod = setInterval(function(){
    if ($('.product-single__description-full').length && $(window).width() >= 768) {
        $('.product-single__description-full').css({
        width: $('.product-slideshow').outerWidth()*0.5,
        marginLeft: parseInt($('.product-single__description-full').css('margin-left')) + $('.product-slideshow').outerWidth()*0.25 + 'px'
        });
        clearInterval(productSingleDescriptionFullWidthMod);
    }
    }, 300);

    $('#PageContainer').on('click', '.variant-input input:radio + label', function(){
    $(this).parents('fieldset').find('.variant-input input:radio + label').removeClass('selected');
    $(this).addClass('selected');
    });

    var productFocusFirstVariant = setInterval(function(){
    if ($('.product-single__variants').length) {
        var sVariant = $('.product-single__variants option[selected]').html();
        var size ='';
        var color ='';
      if (sVariant){
        var variants = sVariant.split('/');
        size = variants[0].trim();
        color = variants[1].split('-')[0].trim();
      }

        $('.variant-input[data-value="'+size+'"] input:radio + label').addClass('selected');
        $('.variant-input[data-value="'+color+'"] input:radio + label').addClass('selected');

        clearInterval(productFocusFirstVariant);
    }
    }, 300);


    var pfsFiltersCountMod = setInterval(function(){
       // console.log('pfsFiltersCountMod initialized');
        if ($('.boost-pfs-filter-tree').length) {
            MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

            var pfsObserver = new MutationObserver(function(mutations, observer) {
                if ($('.boost-pfs-filter-option-amount').not('.filter-count-sanitized').length) {
                    $('.boost-pfs-filter-option-amount').not('.filter-count-sanitized').each(function(){
                        var count = $(this).html().replace(/[()]+/g,'');
                        $(this).addClass('filter-count-sanitized').html(count);
                    });
                }

                if ($('.collection-sidebar .boost-pfs-filter-refine-by-wrapper .boost-pfs-filter-refine-by-items').children().length) {
                    var refineByItemCount = $('.collection-sidebar .boost-pfs-filter-refine-by-wrapper .boost-pfs-filter-refine-by-items').children().length;
                    $('.collection-sidebar .boost-pfs-filter-refine-by-wrapper .boost-pfs-filters-active-count').remove();
                    $('.collection-sidebar .boost-pfs-filter-refine-by-wrapper .boost-pfs-filter-option-title-heading').append('<span class="boost-pfs-filters-active-count">'+refineByItemCount+'</span>');

                    console.log('refine-by-item:'+refineByItemCount);
                }
                else {
                    $('.collection-sidebar .boost-pfs-filter-refine-by-wrapper .boost-pfs-filters-active-count').remove();
                }
            });

            document.querySelectorAll('.boost-pfs-filter-tree').forEach(function($thisTree){
                pfsObserver.observe($thisTree, {
                    subtree: true,
                    attributes: true
                });
            });

            function pfsFiltersValueTitleCase() {
                var brandsCustomTitles = "BAO BAO ISSEY MIYAKE, PLEATS PLEASE ISSEY MIYAKE, DKNY, me ISSEY MIYAKE, DKNY Sport, DKNY Special, OAMC, CLOT, MM6 Maison Margiela, Mulberry. AMIRI, ck Calvin Klein, COMME des GARCONS BLACK, COMME des GARCONS COMME des GARCONS, COMME des GARCONS GIRL, COMME des GARCONS HOMME PLUS, COMME des GARCONS PARFUMS, COMME des GARCONS PLAY, COMME des GARCONS SHIRT, COMME des GARCONS WALLET, JW Anderson, MIISTA, MSGM, STELLA McCARTNEY, TEAM WANG design, PS Paul Smith, rag & bone".split(',').map(brand => brand.trim());
                var brandsLowerCased = brandsCustomTitles.map(brand => brand.toLowerCase());

                $('.boost-pfs-filter-option-brands, .boost-pfs-filter-option-designers, .boost-pfs-filter-option-category, .boost-pfs-filter-option-type, .boost-pfs-filter-option-color').find('.boost-pfs-filter-option-value').not('.boost-pfs-filter-option-value-titlecase, .boost-pfs-filter-option-value-customcase').each(function(){
                    if (brandsLowerCased.includes($(this).html().toLowerCase())) {
                        var i = brandsLowerCased.indexOf($(this).html().toLowerCase());
                        $(this)
                            .html(brandsCustomTitles[i])
                            .attr('data-default-value',$(this).html().toLowerCase())
                            .addClass('boost-pfs-filter-option-value-customcase');
                    }
                    else {
                        $(this).html($(this).html().toLowerCase()).addClass('boost-pfs-filter-option-value-titlecase');
                    }
                });

                // $('.boost-pfs-filter-products').find('.grid-product__vendor').not('.customcase').each(function(){
                //     if (brandsLowerCased.includes($(this).html().toLowerCase())) {
                //         var i = brandsLowerCased.indexOf($(this).html().toLowerCase());
                //         $(this)
                //             .html(brandsCustomTitles[i])
                //             .attr('data-default-value',$(this).html().toLowerCase())
                //             .addClass('customcase');
                //     }
                // });
            }

            // pfsFiltersValueTitleCase();
            // setInterval(pfsFiltersValueTitleCase, 600);
            
            clearInterval(pfsFiltersCountMod);
        }
    }, 300);
   });
  //Zen added
   $(".site-footer ul li a").click(function(e){
     var hurl = $(this).attr('href');
     var target =$(this).attr('target');
     if(target =='_blank'){
      // e.preventDefault();
      // window.open(hurl, "mozillaWindow", "popup"); 
     }
   });
  /*
  $(".grid-product__price").each(function(){
    let price_zero = $(this).html();
      if (price_zero === 'from THB 0' ){
        console.log("price 0");
         $(this).parents(".grid-product").parent().css("display","none");
       }
  });
  */

 //$(".grid-product__tag--sold-out").parents(".grid-product").parent().css("display","none");
 // $(".bcdp-method-wrap").hide();
 // $(".bcdp-method-wrap").css("display","none");
/*   var customerName = '';
  var settings = {
    "url": "https://qdv9nw.api-id.infobip.com/people/2/persons?identifier=nitiruj.a@th.club21global.com&type=EMAIL",
    "method": "GET",
    "timeout": 0,
    "headers": {
        "Authorization": "App 5bc837dfac2176a10a8e3a435cf51f7b-aef588dc-d058-4fdf-a9f2-7ff2e860053f",
        "Accept": "application/json"
    },
   };

$.ajax(settings).done(function (response) {
    console.log("response:"+response);
}); */

})(jQuery);

